import React, { useState, useEffect } from 'react';
import { fetchStaff, createGroupChat } from '../utils/api';
import './_Modal.css';

const CreateGroupChatModal = ({ isOpen, onClose, user, onChatCreated }) => {
    const [staff, setStaff] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState([]);
    const [chatName, setChatName] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (isOpen) {
            fetchStaff().then(response => {
                const allStaff = response.data.filter(member => member.id !== user.id);
                setStaff(allStaff);
            }).catch(err => {
                setError('Failed to fetch staff.');
            });
        }
    }, [isOpen, user.id]);

    const handleAddMember = (staffId) => {
        const staffToAdd = staff.find(s => s.id === parseInt(staffId));
        if (staffToAdd && !selectedStaff.some(s => s.id === staffToAdd.id)) {
            setSelectedStaff([...selectedStaff, staffToAdd]);
        }
    };

    const handleRemoveMember = (staffId) => {
        setSelectedStaff(selectedStaff.filter(s => s.id !== staffId));
    };

    const handleCreateChat = () => {
        if (!chatName.trim()) {
            setError('Chat name is required.');
            return;
        }

        if (selectedStaff.length < 1) { // at least 2 including the creator
            setError('You must select at least 1 other member.');
            return;
        }

        const memberIds = selectedStaff.map(s => s.id);

        createGroupChat(chatName, memberIds).then((res) => {
            onClose();
            if (onChatCreated) {
                onChatCreated(res.data.ID);
            }
        }).catch(err => {
            setError('Failed to create chat.');
        });
    };

    if (!isOpen) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Create Group Chat</h2>
                {error && <p className="error">{error}</p>}
                <div className="form-group">
                    <label>Chat Name</label>
                    <input
                        type="text"
                        value={chatName}
                        onChange={(e) => setChatName(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>Add Members</label>
                    <select onChange={(e) => handleAddMember(e.target.value)} defaultValue="">
                        <option value="" disabled>Select a staff member</option>
                        {staff.map(s => (
                            <option key={s.id} value={s.id}>
                                {s.first_name} {s.last_name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="selected-staff-container">
                    {selectedStaff.map(s => (
                        <div key={s.id} className="selected-staff-member">
                            {s.first_name} {s.last_name}
                            <button onClick={() => handleRemoveMember(s.id)}>x</button>
                        </div>
                    ))}
                </div>
                <div className="actions-centered">
                    <button className="text-button cancel-button" onClick={onClose}>Cancel</button>
                    <button className="text-button submit-button" onClick={handleCreateChat}>Create</button>
                </div>
            </div>
        </div>
    );
};

export default CreateGroupChatModal;
